import styled, { css } from 'styled-components';
import { themeGet } from 'styled-system';
import Box from '../ui-kit/Box';
import Flex from '../ui-kit/Flex';
import Text from '../ui-kit/Text';
import theme from '../ui-kit/themes/theme';

export const TitleWrapper = styled(Text)`
  font-weight: 700;
  font-size: 14px;
`;

export const ValueWrapper = styled(Text)`
  font-size: 12px;
  color: ${themeGet('colors.nightSkyBlack.60')};
`;

export const CostSummaryWrapper = styled(Flex)`
  position: relative;
  ${props =>
    props.withShadow &&
    css`
      border-radius: ${theme.radii[5]}px;
      box-shadow: ${theme.boxShadows[21]}
      border: ${theme.borders[4]};
      background-image: linear-gradient(
        to right,
        ${themeGet('colors.pureWhite.0')} -11%,
        ${themeGet('colors.snowMountainGrey.20')} 138%
      );
    `}
`;

export const AdditionalPackageActionWrapper = styled(Text)`
  font-size: 14px;
  cursor: pointer;
  color: ${themeGet('colors.preciousStoneBlue.100')};
  margin-top: 8px;
  margin-left: 8px;
  font-weight: 700;
  &:hover {
    text-decoration: underline;
  }
`;

export const BadgeWrapper = styled(Text)`
  font-size: 12px;
  margin-left: 8px;
`;

export const SummaryItemsWrapper = styled(Box)`
  max-height: ${props => (!props.scroll ? '100%' : '445px')};
  ${props => (!props.scroll ? '' : 'overflow-y: auto')};
  ${props => (!props.scroll ? '' : 'overflow-x: hidden;')};
`;
